import React, { useState, useEffect } from "react";
import "./partnerForm.scss";
import { MdOutlineMail } from "react-icons/md";
import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
import { Helmet } from "react-helmet";
import ContactForm from "../../components/contactcomp/ContactForm";
import { getCountryPhoneDetails } from "../../utils/countryUtils";

function PartnerForm() {
  const [phoneDetails, setPhoneDetails] = useState({ number: '', flag: '' });

  useEffect(() => {
    const fetchCountryDetails = async () => {
      const details = await getCountryPhoneDetails();
      setPhoneDetails(details);
    };
    
    fetchCountryDetails();
  }, []);

  return (
    <>
      <Helmet>
        <title>Join AxonCare Franchise: For Clinics and Hospitals</title>
        <meta
          name="description"
          content="Partner with AxonCare and expand your healthcare business. Join our franchise network of clinics and hospitals to provide advanced virtual healthcare services."
        />
        <meta
          name="keywords"
          content="AxonCare, healthcare franchise, clinic partnership, hospital partnership, healthcare franchise opportunity, medical franchise"
        />
      </Helmet>
      <div className="contact-parent parent">
        <div className="contact-container container">
          <div className="contact-left contact-body">
            <div className="contact-card">
              <div className="heading custom-heading">Join Our Franchise</div>
              <p className="partner-intro">
                AxonCare is expanding its network of healthcare facilities. Partner with us to offer cutting-edge virtual healthcare services to your patients.
              </p>
              <p className="partner-benefits">
                <strong>Benefits of partnership:</strong>
              </p>
              <ul className="benefits-list">
                <li>Access to AxonCare's AI-powered technology</li>
                <li>Connection to global specialist network</li>
                <li>Enhanced patient experience</li>
                <li>Increased revenue streams</li>
                <li>Marketing and operational support</li>
              </ul>
            </div>
            <div className="contact-card">
              <a href="tel:+14086936337​" className="contact-card-box">
                <span>
                  <IoCallOutline />
                </span>
                <div className="contact-info">
                  <div className="heading custom-heading">Call us:</div>
                  <p>{phoneDetails.number} {phoneDetails.flag}</p>
                </div>
              </a>
              <a
                href="mailto:support@axoncare.io"
                className="contact-card-box"
              >
                <span>
                  <MdOutlineMail />
                </span>
                <div className="contact-info">
                  <div className="heading custom-heading">Email us:</div>
                  <p>support@axoncare.io</p>
                </div>
              </a>
            </div>
          </div>
          <div className="contact-right contact-body">
            <div>
              <ContactForm
                heading="Partner Clinic/Hospital Application"
                description="Please fill out the form below to join our franchise network."
                formType="partner"
                fields={[
                  { name: "fullName", label: "Full Name of the concerned person", type: "text", required: true },
                  { name: "contactNumber", label: "Contact Number", type: "tel", required: true },
                  { name: "email", label: "Email Address", type: "email", required: true },
                  { name: "location", label: "Location of the clinic/hospital", type: "text", required: true },
                  { name: "message", label: "Message", type: "textarea", required: true }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerForm; 